import React, { useEffect, useMemo, useState } from "react";
import Slider from "react-slick";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";

import { API_BASE } from "../config";

export default function Branches() {
    const [branches, setBranches] = useState([]);
    const [loading, setLoading] = useState(true);

    // Lightbox
    const [lbOpen, setLbOpen] = useState(false);
    const [lbSlides, setLbSlides] = useState([]);
    const [lbIndex, setLbIndex] = useState(0);

    useEffect(() => {
        const load = async () => {
            setLoading(true);
            const r = await fetch(`${API_BASE}/api/branches`);
            const data = await r.json().catch(() => []);
            setBranches(Array.isArray(data) ? data : []);
            setLoading(false);
        };
        load();
    }, []);

    const openLightbox = (imgs, index) => {
        setLbSlides(imgs.map((src) => ({ src })));
        setLbIndex(index);
        setLbOpen(true);
    };

    // Slider ayarları (responsive)
    const slickSettings = useMemo(
        () => ({
            dots: true,
            arrows: true,
            infinite: false,
            speed: 300,
            slidesToShow: 3,
            slidesToScroll: 1,
            swipeToSlide: true,
            adaptiveHeight: false,
            responsive: [
                { breakpoint: 900, settings: { slidesToShow: 2 } },
                { breakpoint: 520, settings: { slidesToShow: 1 } },
            ],
        }),
        []
    );

    return (
        <div className="container branchPage">
            <h2 className="sectionTitle">Şubeler</h2>

            {loading ? (
                <div>Yükleniyor...</div>
            ) : branches.length === 0 ? (
                <div>Henüz şube eklenmemiş.</div>
            ) : (
                <div className="branchAlbums">
                    {branches.map((b) => {
                        const imgs = (b.photos || []).map((p) => `${API_BASE}${p.imageUrl}`);

                        return (
                            <section className="branchAlbum" key={b.id}>
                                <div className="branchAlbumTop">
                                    <div className="branchAlbumTitle">{b.name}</div>
                                    <div className="branchAlbumCount">{imgs.length} fotoğraf</div>
                                </div>

                                {imgs.length === 0 ? (
                                    <div className="branchEmpty">Bu şube için henüz fotoğraf yok.</div>
                                ) : (
                                    <div className="slickWrap">
                                        <Slider {...slickSettings}>
                                            {imgs.map((src, idx) => (
                                                <div key={`${b.id}-${idx}`} className="slickItem">
                                                    <button
                                                        type="button"
                                                        className="branchSlideBtn"
                                                        onClick={() => openLightbox(imgs, idx)}
                                                    >
                                                        <img className="branchSlideImg" src={src} alt={`${b.name} ${idx + 1}`} />
                                                    </button>
                                                </div>
                                            ))}
                                        </Slider>
                                    </div>
                                )}
                            </section>
                        );
                    })}
                </div>
            )}

            <Lightbox
                open={lbOpen}
                close={() => setLbOpen(false)}
                slides={lbSlides}
                index={lbIndex}
                on={{ view: ({ index }) => setLbIndex(index) }}
            />
        </div>
    );
}